import {MSG_ERRO_SERVIDOR} from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    esperandoRespostaSolicitacao: false,
    error: false,
    error_elo: false,
    mensagem: '',
    loadingCreditos: false,
    loadingImpressao: false,
    creditosTelaInicial: [],
    creditos: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){

        case 'NC_IMPRESSAO_SOLICITADA':
            return {...state, esperandoRespostaSolicitacao: true, error: false, error_elo: false, mensagem: '', loadingCreditos: false};

        case 'NC_IMPRESSAO_RECEBIDA':
            return {...state, esperandoRespostaSolicitacao: false,mensagem: 'sucesso', loadingCreditos: false};

        case 'NC_ERRO_IMPRESSAO_RECEBIDO':
            return {...state, esperandoRespostaSolicitacao: false, mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR, error: true, loadingCreditos: false};

        case 'NC_ERRO_ELO':
            return { ...state, esperandoRespostaSolicitacao: false, error_elo: true, loadingCreditos: false }

        case 'NC_LIMPAR_MENSAGEM':
            return {...state , esperandoRespostaSolicitacao: false, error: false, error_elo: false, mensagem: '', loadingCreditos: false};

        case 'NC_CREDITOS_SOLICITADOS':
            return {...state, loadingCreditos: true, loadingImpressao: false, error: false, error_elo: false, mensagem: ''};

        case 'NC_CREDITOS_INICIAL':
            return {...state, loadingCreditos: false, loadingImpressao: false, error: null, mensagem: ''}    
            
        case 'NC_CREDITOS_RECEBIDOS':
            let creditosTelaInicial = state.creditosTelaInicial;
            if(state.creditosTelaInicial===INITIAL_STATE.creditosTelaInicial){
                creditosTelaInicial=Array.isArray(action.payload.creditosTO) ? action.payload.creditosTO : [action.payload.creditosTO]
            }
        return {...state, 
            creditos: Array.isArray(action.payload.creditosTO) ? action.payload.creditosTO : [action.payload.creditosTO],
            creditosTelaInicial,
            loadingCreditos: false, loadingImpressao: false
        };
        default:
            return state;
    }
}
